import React from 'react';
import { Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import Button from '../../components/Button/Button';
import Markup from '../../base/Markup/Markup';
import Typography, {
  TypographyContextProvider,
} from '../../components/Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import isFadeEnabled from '../../utils/isFadeEnabled';
import { parsePadding } from '../../utils/parseSpacing';
import { CentredTextSectionStoryblok } from '../../types/storyblok';

const CentredTextSection = ({
  title,
  titleTag,
  richText,
  buttonText,
  buttonUrl,
  colourScheme,
  padding,
}: CentredTextSectionStoryblok) => (
  <TypographyContextProvider value={{ colourScheme }}>
    <Box
      as="div"
      sx={{ ...parsePadding(padding || '8 3 8 3, 9 4 9 4, 10 4 10 4') }}
      backgroundColor={colourMatching(colourScheme)}
    >
      <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
        <Scene classToggle="full-opacity">
          <Box
            className={isFadeEnabled() ? 'zero-opacity' : ''}
            maxWidth="40em"
            mx="auto"
            textAlign="center"
          >
            {title && (
              <Typography
                component={titleTag || 'h2'}
                variant="h2"
                mb="0.75em"
                mx="auto"
              >
                {title}
              </Typography>
            )}

            {richText && <Markup content={richText} />}

            {buttonText && (
              <Box mt="50px">
                <Button
                  href={buttonUrl || undefined}
                  arrow
                  colourScheme={colourScheme}
                >
                  {buttonText}
                </Button>
              </Box>
            )}
          </Box>
        </Scene>
      </Controller>
    </Box>
  </TypographyContextProvider>
);

export default CentredTextSection;
